import {Injectable} from '@angular/core';
import {ApiService, ModelBase} from '@app/api/api.service';

export interface Roles extends ModelBase {
}

@Injectable({
    providedIn: 'root'
})

export class RolesApiService {

    constructor(private apiService: ApiService) {
    }

    public async getUserRoles(): Promise<any> {
        return await this.apiService.getResponseJson(
            {
                urlPart: '/roles',
                method: 'GET'
            });
    }

    public async getRolesPrivilegesMatrix(): Promise<any> {
        return await this.apiService.getResponseJson(
            {
                urlPart: '/roles/privileges',
                method: 'GET'
            });
    }
}